import React, { FC, useEffect, useState } from "react";
import { Form, Modal, Button, Alert, Row, Col, Table } from "react-bootstrap";
import { isResponseError, OptionType, ResponseErrorType } from "../../../../types/CommonType";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_COMMON_CANCEL, LANG_COMMON_DIAGNOSIS, LANG_COMMON_EVOLUTION, LANG_COMMON_LEGAL_ID, LANG_COMMON_LOADING, LANG_COMMON_MEDICAL_RECORD_NUMBER, LANG_COMMON_NAME, LANG_COMMON_NEW, LANG_COMMON_PATIENT, LANG_COMMON_SAVE, LANG_ERROR, LANG_WARNING_FILL_ALL } from "../../../../lang";
import { TreatmentMedicationType, TreatmentType } from "../../../../types/TreatmentType";
import { TreatmentModel } from "../../../../models/TreatmentModel";
import CustomSelect from "../../../../components/form/CustomSelect";
import InputMask from 'react-input-mask';
import TreatmentMedicationRow from "./TreatmentMedicationRow";
import TreatmentMedicationModal from "./TreatmentMedicationModal";

interface Props {
    onChange: (medications: TreatmentMedicationType[]) => void
    medications: TreatmentMedicationType[]
    treatment: TreatmentType | null
    treatmentType?: string
    type: string
    prescription?: boolean
    readOnly?: boolean
    onEditClick?: (index: number) => void
}

const TreatmentMedications: FC<Props> = ({ onChange, medications, treatment, type, prescription = false, treatmentType, readOnly = true, onEditClick }) => {
    const intl = useIntl();
    const DefaultErrorMsg = intl.formatMessage(LANG_ERROR);
    const [data, setData] = useState<TreatmentMedicationType[]>(medications.map((m) => {return {...m, print: false}}));
    const [selectAll, setSelectAll] = useState(false);    

    useEffect(() => {
        onChange(data);
    }, [data]);

    const updatePrint = (index: number, print: boolean) => {
        const newData = data;
        newData[index].print = print;
        setData([...newData]);
    }

    return (
        <Row>
            <Col lg={12}>
                <div className="title-divider">
                    <h6>{type === 'TREAT'
                        ? treatmentType && TreatmentModel().isTreatmentTypeTE(treatmentType) ? 'Preparo de Endométrio (Medicações)': 'Estímulo Ovariano Controlado (Medicações)'
                        : 'Trigger (Medicações)'
                    }</h6>
                    <hr />
                </div>
            </Col>

            <Col lg={12}>
                <Table striped>
                    <thead>
                        <tr>
                            <th>Medicação</th>
                            <th>Dosagem</th>
                            <th>Posologia</th>
                            <th>Data início</th>
                            <th>Data fim</th>
                            <th>Horário</th>
                            {!prescription && (<th>Options</th>)}
                            {prescription && (<th><Form.Check type="checkbox" onChange={() => {
                                for(let i in data) {
                                    updatePrint(parseInt(i), !selectAll);
                                }
                                setSelectAll(!selectAll);
                            }} checked={selectAll}></Form.Check></th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <TreatmentMedicationRow
                                key={item.id}
                                item={item}
                                index={index}
                                type={type}
                                prescription={prescription}
                                data={data}
                                setData={setData}
                                updatePrint={updatePrint}
                                readOnly={readOnly}
                                onEditClick={onEditClick}
                            />
                        ))}
                    </tbody>
                </Table>
            </Col>
        </Row>
    )
}

export default TreatmentMedications;